const messagesAr = {
  about: 'حول',
  acceptanceCriteria: 'معايير القبول',
  accomplishments: 'الإنجازات',
  actions: 'الإجراءات',
  activity: 'النشاط',
  activatePod: 'تفعيل POD',
  activePods: 'POD نشطة',
  add: 'إضافة',
  addBlocker: 'إضافة معلومات العائق',
  addingCandidateWait: 'جاري إضافة المرشح انتظر...',
  addPortfolio: 'إضافة محفظة',
  addStakeholder: 'إضافة صاحب مصلحة',
  addVideoUpdate: 'إضافة تحديث فيديو',
  findAgents: 'البحث عن الوكلاء',
  all: 'الكل',
  allReporters: 'جميع المراسلين',
  allRepoCheckins: 'جميع تسجيل دخول المستودع',
  approve: 'موافقة',
  approved: 'موافق عليه',
  approvalRequests: 'طلبات الموافقة',
  approvedPRCount: 'عدد PR المعتمدة',
  assignedItems: 'العناصر المخصصة',
  availability: 'التوفر',
  availableDate: 'التاريخ المتاح',
  backToPods: 'العودة إلى POD الخاصة بي',
  basicInformation: 'المعلومات الأساسية',
  blocker: 'عائق',
  blockerDetails: 'تفاصيل العائق',
  blockers: 'العوائق',
  board: 'اللوحة',
  browseTalent: 'تصفح المواهب',
  bugs: 'الأخطاء',
  calendlyUrl: 'رابط Calendly',
  cancel: 'إلغاء',
  candidates: 'المرشحون',
  categories: 'الفئات',
  certifications: 'الشهادات',
  certificationUrl: 'رابط الشهادة',
  checkBoxBlocker: 'ضع علامة في هذا المربع إذا كان عائقاً',
  ciCdPipeline: 'خط أنابيب CI/CD',
  clear: 'مسح',
  client: 'العميل',
  clickHereUploadVideoClip: 'انقر هنا لتحميل مقطع فيديو!',
  cloudCost: 'تكلفة السحابة',
  code: 'أسطر الكود',
  codeSmells: 'روائح الكود',
  commentHere: 'علق هنا...',
  category: 'الفئة',
  comments: 'التعليقات',
  companyName: 'اسم الشركة',
  copied: 'تم النسخ!',
  copyright: 'حقوق الطبع والنشر © 2025-الحاضر Brilli Global, Inc. جميع الحقوق محفوظة.',
  copyToClipboard: 'نسخ إلى الحافظة',
  cost: 'التكلفة',
  costDetails: 'تفاصيل التكلفة',
  country: 'البلد',
  create: 'إنشاء',
  createArt: 'إنشاء ART',
  createGig: 'إنشاء حل',
  createPod: 'إنشاء POD',
  createProfile: 'إنشاء ملف شخصي',
  createProfileOpportunity: 'أنشئ ملفك الشخصي في قاعدة بيانات المواهب لدينا ليتم تضمينك في فرص العمل عن بُعد المختلفة.',
  createTask: 'إنشاء مهمة',
  createYourOwnPod: 'أنشئ POD الخاص بك وتصفح المشاريع',
  creatingProfile: 'جاري إنشاء الملف الشخصي',
  currency: 'العملة',
  currentlyAvailable: 'متاح حالياً',
  currentWeek: 'الأسبوع الحالي',
  dashboard: 'لوحة القيادة',
  date: 'التاريخ',
  dateRangeFilter: 'فلتر النطاق الزمني',
  deactivatePod: 'إلغاء تفعيل POD',
  deactivateToUpdate: 'قم بإلغاء تفعيل POD لتحديث POD!',
  defects: 'العيوب',
  delete: 'حذف',
  deletePod: 'حذف POD',
  description: 'الوصف',
  detailsForGitHubRepo: 'تفاصيل مستودع GitHub',
  done: 'إغلاق',
  Done: 'تم',
  doraMetrics: 'مقاييس Dora',
  dueDate: 'تاريخ الاستحقاق',
  duplicatedLinesDensity: 'كثافة الأسطر المكررة',
  edit: 'تحرير',
  education: 'التعليم',
  educationAndCertifications: 'التعليم والشهادات',
  email: 'البريد الإلكتروني',
  podTime: 'وقت POD',
  createHub: 'إنشاء مركز',
  createSolution: 'إنشاء حل',
  podVelocity: 'سرعة POD',
  podBlockers: 'عوائق POD',
  podsync: 'مزامنة POD',
  endDate: 'تاريخ الانتهاء',
  enterEmailToInvite: 'أدخل بريد إلكتروني للدعوة',
  enterPodMission: 'أدخل مهمة POD',
  enterPodName: 'أدخل اسم POD',
  enterStoryDescription: 'أدخل وصف القصة',
  executionDate: 'تاريخ التنفيذ',
  executionID: 'معرف التنفيذ',
  externalPod: 'POD خارجي',
  fileNameNoSpaces: 'لا يجب أن يحتوي اسم الملف على مسافات',
  fileUpload: 'تحميل ملف',
  findBestFreelancers: 'ابحث عن أفضل المستقلين أو مجموعات المواهب لإنجاز مشاريعك بوتيرة أسرع!',
  findBestPod: 'ابحث عن POD التي تتناسب مع خبرتك/مهاراتك',
  findPods: 'البحث عن POD',
  findTalent: 'البحث عن المواهب',
  findYourBestTalentPod: 'ابحث عن أفضل POD للمواهب لديك',
  firstName: 'الاسم الأول',
  focus: 'التركيز',
  gitHubRepo: 'مستودع GitHub',
  gitHubUsername: 'اسم مستخدم GitHub',
  github: 'Github',
  githubSummary: 'ملخص GitHub',
  githubUrl: 'رابط Github',
  githubUser: 'مستخدم GitHub',
  giveRating: 'إعطاء تقييم',
  globalWorkPlatform: 'منصة العمل العالمية',
  home: 'الرئيسية',
  hoursPerWeek: 'ساعات في الأسبوع',
  inactivePod: 'POD غير نشط',
  individual: 'فردي',
  industry: 'الصناعة',
  inProgress: 'قيد التقدم',
  institute: 'المعهد',
  internalPod: 'POD داخلي',
  invite: 'دعوة',
  invoices: 'الفواتير',
  issueKey: 'مفتاح المشكلة',
  issueStatus: 'حالة المشكلة',
  issueSummary: 'ملخص المشكلة',
  jiraIssue: 'مشكلة Jira',
  jiraIssues: 'مشاكل Jira',
  jiraItem: 'عنصر Jira',
  jiraTimeDetails: 'سجل الوقت',
  jiraUsername: 'اسم مستخدم Jira',
  keepDoing: 'استمر في فعل',
  keyword: 'الكلمة المفتاحية',
  languageSpoken: 'اللغة المنطوقة',
  lastName: 'اسم العائلة',
  latestSprintVelocity: 'أحدث سرعة سبرينت',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'رابط LinkedIn',
  linesOfCodeByDay: 'أسطر الكود حسب اليوم',
  listOfTalents: 'قائمة المواهب',
  loading: 'جاري التحميل',
  loadingAcceptanceCriteria: 'جاري تحميل معايير القبول',
  loadingStoryDescription: 'جاري تحميل وصف القصة',
  loadingTestCases: 'جاري تحميل حالات الاختبار',
  logOut: 'تسجيل الخروج',
  login: 'تسجيل الدخول',
  manage: 'إدارة',
  manageActivities: 'إدارة أنشطة POD اليومية والتحديثات',
  manageProfile: 'إدارة الملف الشخصي',
  manageProfileHere: 'إدارة ملفك الشخصي هنا',
  managePod: 'إدارة POD',
  managePods: 'إدارة جميع POD وأنشطتها',
  markComplete: 'وضع علامة مكتمل',
  middleName: 'الاسم الأوسط',
  myPods: 'POD الخاصة بي',
  myTasks: 'مهامي',
  name: 'الاسم',
  ncloc: 'Ncloc',
  newActivityUpdate: 'تحديث نشاط جديد',
  next: 'التالي',
  noArtOptionsAvailable: 'لا توجد خيارات ART متاحة',
  noBlockers: 'لا توجد عوائق',
  noCandidates: 'لم يتم إضافة مرشحين',
  noCandidatesAddedToPod: 'لم يتم إضافة مرشحين إلى POD!',
  noCandidateReviews: 'لا توجد مراجعات للمرشحين.',
  noData: 'لا توجد بيانات',
  noDataAvailable: 'لا توجد بيانات متاحة',
  noExperience: 'لا توجد خبرة',
  noMatchingPods: 'لا توجد POD متطابقة متاحة',
  noNotifications: 'لا توجد إشعارات',
  noPodActivity: 'ليس لديك أي نشاط POD',
  noPods: 'ليس لديك أي POD',
  noPodTasks: 'ليس لديك أي مهام POD',
  noReviews: 'لا توجد مراجعات.',
  noStakeholders: 'لا توجد أصحاب مصلحة لهذا POD',
  noSubscription: 'ليس لديك أي خطة اشتراك',
  noVideoAvailable: 'لا يوجد فيديو متاح',
  notifications: 'مستلم الإشعارات',
  otherInformation: 'معلومات أخرى',
  pending: 'معلق',
  pendingPods: 'POD معلقة',
  phoneNumber: 'رقم الهاتف',
  pipelineExecutionDetails: 'تفاصيل تنفيذ خط الأنابيب',
  pipelineName: 'اسم خط الأنابيب',
  pipelineVersion: 'إصدار خط الأنابيب',
  pleaseEnterStoryDescription: 'يرجى إدخال وصف القصة والنقر على إرسال',
  POD: 'POD',
  podActivities: 'أنشطة POD',
  podActivity: 'نشاط POD',
  podAnalytics: 'تحليلات POD',
  podAssist: 'مساعد POD',
  podAutomation: 'أتمتة POD',
  podBoard: 'لوحة POD',
  podCategories: 'فئات POD',
  podDescription: 'وصف POD',
  podExperience: 'خبرة POD',
  podFeedback: 'ملاحظات POD',
  podMetrics: 'مقاييس POD',
  podName: 'اسم POD',
  podQuery: 'استعلام POD',
  podRequests: 'طلبات POD',
  podRetro: 'استعراض POD',
  podSize: 'حجم POD',
  podTasks: 'مهام POD',
  podTaskDescription: 'وصف مهمة POD',
  podTaskDueDate: 'تاريخ استحقاق مهمة POD',
  podTaskName: 'اسم مهمة POD',
  podTaskOwner: 'مالك مهمة POD',
  podTaskStatus: 'حالة مهمة POD',
  podTechStack: 'المكدس التقني لـ POD',
  podTeamMember: 'عضو فريق POD',
  podType: 'نوع POD',
  portfolio: 'المحفظة',
  portfolioUrl: 'رابط المحفظة',
  post: 'نشر',
  postActivity: 'نشر النشاط',
  postPodActivity: 'نشر نشاط POD',
  postRequirement: 'نشر المتطلب',
  posting: 'جاري النشر...',
  postedDate: 'تاريخ النشر',
  postedRequirements: 'متطلبات POD المنشورة',
  positionName: 'اسم المنصب',
  prCount: 'عدد PR',
  preferredWorkHours: 'ساعات العمل المفضلة',
  prev: 'السابق',
  previousPods: 'POD السابقة',
  previousWeek: 'الأسبوع السابق',
  primarySkill: 'المهارة الأساسية',
  privacyPolicy: 'سياسة الخصوصية',
  privatePods: 'POD خاصة',
  prSummary: 'ملخص PR',
  projectKey: 'مفتاح المشروع',
  profileLink: 'رابط الملف الشخصي',
  profileVisibility: 'رؤية الملف الشخصي',
  public: 'عام',
  qualification: 'المؤهل',
  ratePerHour: 'السعر بالساعة',
  ratePerMonth: 'السعر بالشهر',
  recentSearches: 'البحثات الأخيرة',
  region: 'المنطقة',
  register: 'تسجيل',
  resetPassword: 'إعادة تعيين كلمة المرور',
  restricted: 'مقيد',
  retro: 'استعراض',
  review: 'المراجعة والتقييم',
  revisionSummary: 'ملخص المراجعة',
  revisionURL: 'رابط المراجعة',
  resume: 'السيرة الذاتية',
  resumeLink: 'عرض السيرة الذاتية',
  rowsPerPage: 'صفوف لكل صفحة',
  save: 'حفظ',
  search: 'بحث',
  searchProjects: 'البحث عن المشاريع',
  secondarySkill: 'المهارة الثانوية',
  select: 'اختيار',
  selectArtName: 'اختيار اسم ART',
  selectAUser: 'اختيار مستخدم',
  selectFilter: 'اختيار فلتر',
  applyFilters: 'تطبيق الفلاتر',
  selectItemsPerPage: 'اختيار عناصر لكل صفحة',
  selectJiraIssues: 'اختيار مشاكل Jira',
  selectPod: 'اختيار POD',
  selectPodTeamMember: 'اختيار عضو فريق POD',
  selectPods: 'اختيار POD',
  services: 'الخدمات',
  setting: 'الإعداد',
  shareableLink: 'رابط قابل للمشاركة',
  signUpToGetStarted: '"سجل" أدناه للبدء!',
  getStarted: 'البدء',
  skills: 'المهارات',
  skillsAndExpertise: 'المهارات والخبرات',
  sonarqubeprojectkey: 'مفتاح مشروع Sonarqube',
  sonarqubeStats: 'إحصائيات Sonarqube',
  specialization: 'التخصص',
  sprintVelocity: 'سرعة السبرينت',
  sprint: 'سبرينت',
  spotsLeft: 'المقاعد المتبقية',
  startDate: 'تاريخ البداية',
  startDoing: 'ابدأ في فعل',
  status: 'الحالة',
  stopDoing: 'توقف عن فعل',
  storyDescription: 'وصف القصة',
  stories: 'القصص',
  submit: 'إرسال',
  submittedDate: 'تاريخ الإرسال',
  submittedPRCount: 'عدد PR المرسلة',
  subscription: 'الاشتراك',
  talentApprovalRequests: 'طلبات موافقة المواهب',
  talentCode: 'كود المواهب',
  taskForm: 'نموذج المهمة',
  taskManager: 'مدير المهام',
  taskName: 'اسم المهمة',
  tasks: 'المهام',
  teamMember: 'عضو الفريق',
  techStack: 'المكدس التقني',
  termsOfService: 'شروط الخدمة',
  testCases: 'حالات الاختبار',
  time: 'الوقت',
  timeLog: 'سجل الوقت',
  timeSubmit: 'إرسال الوقت',
  timeZone: 'المنطقة الزمنية',
  toDo: 'للقيام',
  todaysFocus: 'تركيز اليوم',
  totalLinesChangedLastWeek: 'إجمالي الأسطر المتغيرة الأسبوع الماضي',
  totalLinesChangedThisWeek: 'إجمالي الأسطر المتغيرة هذا الأسبوع',
  totalPRCount: 'إجمالي عدد PR',
  university: 'الجامعة',
  update: 'تحديث',
  updateProfileHere: 'حدث ملفك الشخصي هنا',
  updatingVisibility: 'جاري تحديث الرؤية...',
  upload: 'رفع',
  userStory: 'قصة المستخدم',
  validFrom: 'صالح من',
  validTill: 'صالح حتى',
  talentexplorer: 'مستكشف المواهب',
  interviewrequests: 'طلبات المقابلة',
  videoUrl: 'رابط الفيديو',
  view: 'عرض',
  viewActivities: 'عرض الأنشطة',
  viewDetails: 'عرض التفاصيل',
  viewPodActivities: 'عرض أنشطة POD',
  viewPodDetails: 'عرض تفاصيل POD',
  viewProfile: 'عرض الملف الشخصي',
  viewTasks: 'عرض المهام',
  viewTimeEntries: 'عرض إدخالات الوقت',
  viewVideo: 'عرض الفيديو',
  visitFindTalent: 'يرجى زيارة صفحة "البحث عن المواهب" وإضافة أفراد موهوبين إلى POD الخاص بك.',
  vulnerabilities: 'الثغرات',
  welcome: 'مرحباً بك في Artemy.ai!',
  workExperience: 'خبرة العمل',
  yourPod: 'POD الخاص بك',
  yourPods: 'POD الخاصة بك',
  yourPostedPodActivity: 'نشاط POD المنشور',
  
  findTickets: 'البحث عن التذاكر',
  epics: 'الملاحم',
  date: 'التاريخ',
  talent: 'المواهب',
  focus: 'التركيز',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ الانتهاء',
  status: 'الحالة',
  allStatus: 'جميع الحالات',
  blocked: 'محجوب',
  onTrack: 'على المسار الصحيح',
  activityDetails: 'تفاصيل النشاط',
  jiraIssues: 'مشاكل Jira',
  todaysFocus: 'تركيز اليوم',
  accomplishments: 'الإنجازات',
  blockers: 'العوائق',
  videoUpdate: 'تحديث الفيديو',
  comments: 'التعليقات',
  addBlockerInformation: 'إضافة معلومات العائق',
  blockerDetails: 'تفاصيل العائق',
  cancel: 'إلغاء',
  saveChanges: 'حفظ التغييرات',
  selectJiraIssues: 'اختيار مشاكل Jira',
  design: 'التصميم',
  development: 'التطوير',
  testing: 'الاختبار',
  bugFix: 'إصلاح الأخطاء',
  documentation: 'التوثيق',
  myPods: 'POD الخاصة بي',
  postRetro: 'نشر استعراض',
  newRetro: 'استعراض جديد',
  startDoing: 'ابدأ في فعل',
  stopDoing: 'توقف عن فعل',
  keepDoing: 'استمر في فعل',
  viewRetros: 'عرض الاستعراضات',
  podRetroFeedback: 'ملاحظات استعراض POD',
  selectSprint: 'اختيار سبرينت',
  thisTaskIsBlocker: 'هذه المهمة عائق',
  category: 'الفئة',
  taskCreatedSuccessfully: 'تم إنشاء المهمة بنجاح!',
  taskManagement: 'إدارة المهام',
  searchJiraIssues: 'البحث عن مشاكل JIRA...',
  creatingTask: 'جاري إنشاء المهمة...',
  createTask: 'إنشاء مهمة',
  description: 'الوصف',
  dueDate: 'تاريخ الاستحقاق',
  commentsHistory: 'تاريخ التعليقات',
  noCommentsYet: 'لا توجد تعليقات حتى الآن',
  writeAComment: 'اكتب تعليقاً...',
  all: 'الكل',
  blockerStatus: 'حالة العائق',
  blockedTasks: 'المهام المحجوبة',
  unblockedTasks: 'المهام غير المحجوبة',
  clearDateRange: 'مسح النطاق الزمني',
  selectDateRange: 'اختيار النطاق الزمني',
  showAllTime: 'إظهار كل الأوقات',
  noTasksFound: 'لم يتم العثور على مهام',
  noLinkedIssues: 'لا توجد مشاكل مرتبطة',
  timeSheet: 'ورقة الوقت',
  podTimeSheet: 'ورقة وقت POD',
  userStory: 'قصة المستخدم',
  hours: 'ساعات',
  minutes: 'دقائق',
  actions: 'الإجراءات',
  submitTimeEntries: 'إرسال إدخالات الوقت',
  selectCategory: 'اختيار فئة',
  selectStory: 'اختيار قصة',
  addRow: 'إضافة صف',
  podSelection: 'اختيار POD',
  selectPodToView: 'اختر POD لعرض فلاتر السبرينت والمواهب',
  toDo: 'للقيام',
  podAssist: 'مساعد POD',
  inProgress: 'قيد التقدم',
  done: 'تم',
  selectPodsRequired: 'اختيار POD (مطلوب)',
  enterStoryDescription: 'أدخل وصف القصة',
  podSyncSummaries: 'ملخصات مزامنة POD',
  enterMeetingUrl: 'أدخل رابط الاجتماع...',
  searchInSummaries: 'البحث في الملخصات...',
  dateAndTime: 'التاريخ والوقت',
  quickTimeRange: 'النطاق الزمني السريع',
  sortByDate: 'ترتيب حسب التاريخ',
  selectTalents: 'اختيار المواهب',
  filterBySpecificCandidates: 'فلترة حسب مرشحين محددين (اختياري)',
  talentSelection: 'اختيار المواهب',
  priority: 'الأولوية',
  addComment: 'إضافة تعليق',
  taskDetails: 'تفاصيل المهمة',
  summary: 'الملخص',
  addMeeting: 'إضافة اجتماع',

  podAutomation: 'أتمتة POD',
  uploading: 'جاري الرفع...',
  uploadFile: 'رفع ملف',
  send: 'إرسال',
  submitting: 'جاري الإرسال...',
  enterYourQuestionHere: 'أدخل سؤالك هنا',
  submitTheResults: 'إرسال النتائج',
  export: 'تصدير',
  podInsights: 'رؤى POD',
  askQuestionsAboutYourPod: 'اسأل أسئلة حول أنشطة POD وأعضاء الفريق والمزيد',
  welcomeToPodInsights: 'مرحباً بك في رؤى POD!',
  startByAskingQuestionsLike: 'ابدأ بطرح أسئلة مثل',
  showAllPodActivitiesThatHadBlockers: 'إظهار جميع أنشطة POD التي لديها عوائق',
  listAllCandidatesAndTheirPods: 'قائمة جميع المرشحين و POD الخاصة بهم',
  showStakeholdersFromIndia: 'إظهار أصحاب المصلحة من الهند',
  askAnythingAboutYourPods: 'اسأل أي شيء حول POD وأعضاء الفريق والأنشطة...',
  sending: 'جاري الإرسال...',
  analyzingYourQuestion: 'جاري تحليل سؤالك...',
  pipelineCICD: 'خط أنابيب CI/CD',
  tickets: 'التذاكر',
  metricName: 'اسم المقياس',
  metricValue: 'قيمة المقياس',
  commentsHistory: 'تاريخ التعليقات',
  noCommentsYet: 'لا توجد تعليقات حتى الآن',
  writeAComment: 'اكتب تعليقاً...',
  solutionManagement: 'إدارة الحلول',
  searchSolutions: 'البحث عن الحلول...',
  refresh: 'تحديث',
  createNewSolution: 'إنشاء حل جديد',
  solutionName: 'اسم الحل',
  solutionDescription: 'وصف الحل',
  updateSolution: 'تحديث الحل',
  createSolution: 'إنشاء حل',
  confirmSolutionDeletion: 'هل أنت متأكد من أنك تريد حذف الحل',
  artManagement: 'إدارة ART',
  podManagement: 'إدارة POD',
  searchPods: 'البحث عن POD...',
  viewPod: 'عرض POD',
  searchARTs: 'البحث عن ART...',
  noARTsFound: 'لم يتم العثور على ART. أنشئ أول ART لك بالنقر على زر "إنشاء ART جديد".',
  createNewART: 'إنشاء ART جديد',
  selectGig: 'اختيار مشروع',
  artName: 'اسم ART',
  artDescription: 'وصف ART',
  createART: 'إنشاء ART',
  confirmDeletion: 'تأكيد الحذف',
  confirmARTDeletion: 'هل أنت متأكد من أنك تريد حذف ART',
  primaryLanguage: 'اللغة الأساسية',
  selectSkills: 'اختيار المهارات',
  timeZone: 'المنطقة الزمنية',
  updateART: 'تحديث ART',
  somethingWentWrong: 'حدث خطأ ما',
  reloadPage: 'إعادة تحميل الصفحة',
  privatePods: 'POD خاصة',
  activePods: 'POD نشطة',
  completedPods: 'POD مكتملة',
  pendingPods: 'POD معلقة',
  loadingPods: 'جاري تحميل POD...',
  retry: 'إعادة المحاولة',
  noPodsFound: 'لم يتم العثور على POD',
  createFirstPod: 'أنشئ أول POD لك للبدء',
  previous: 'السابق',
  showing: 'عرض',
  size: 'الحجم',
  teamSize: 'حجم الفريق',
  activeMembers: 'الأعضاء النشطون',
  stakeholders: 'أصحاب المصلحة',
  podManagers: 'مديرو POD',
  addManager: 'إضافة مدير',
  podManager: 'مدير POD',
  noManagersAssignedYet: 'لم يتم تعيين مديرين حتى الآن',
  addManagersToHelpOversee: 'أضف مديرين للمساعدة في الإشراف على هذا POD',
  noStakeholdersYet: 'لا يوجد أصحاب مصلحة حتى الآن',
  settings: 'الإعدادات',
  deletePod: 'حذف POD',
  addPodManager: 'إضافة مدير POD',
  selectManagerToInvite: 'اختر مديراً لدعوته إلى هذا POD:',
  noManagersAvailableToInvite: 'لا يوجد مديرون متاحون للدعوة.',
  selectAManager: 'اختيار مدير',
  selectedManager: 'المدير المختار',
  inviteManager: 'دعوة مدير',
  noTeamMembersYet: 'لا يوجد أعضاء فريق حتى الآن',
  startByInvitingMembers: 'ابدأ بدعوة الأعضاء إلى POD الخاص بك',
  inviteTeamMembers: 'دعوة أعضاء الفريق',
  existingMembers: 'الأعضاء الحاليون',
  inviteByEmail: 'الدعوة بالبريد الإلكتروني',
  searchByNameOrSkills: 'البحث بالاسم أو المهارات...',
  optionalSelectUserToNotify: 'اختياري: اختر مستخدماً لإعلامه عبر Slack',
  pleaseSelectPodToEnableFields: 'يرجى اختيار POD لتمكين الحقول الأخرى',
  selectedCandidates: 'المرشحون المختارون',
  selectCandidatesToInvite: 'اختر المرشحين لدعوتهم إلى هذا POD',
  availableCandidates: 'المرشحون المتاحون',
  inviteNewMembersByEmail: 'دعوة أعضاء جدد بالبريد الإلكتروني',
  emailAddresses: 'عناوين البريد الإلكتروني',
  enterEmailAddresses: 'أدخل عناوين البريد الإلكتروني (مفصولة بفواصل)',
  hidePodTeamMembers: 'إخفاء أعضاء فريق POD هذا في قسم البحث عن POD (مرئي حالياً)',
  technicalDetails: 'التفاصيل التقنية',
  currentTeamSize: 'حجم الفريق الحالي',
  communicationDetails: 'تفاصيل التواصل',
  podReview: 'مراجعة POD',
  rating: 'التقييم',
  writeReview: 'كتابة مراجعة',
  shareYourExperience: 'شارك تجربتك مع هذا POD...',
  submitReview: 'إرسال المراجعة',
  viewPod: 'عرض POD',
  managePod: 'إدارة POD',
  editPod: 'تحرير POD',
  skillsAndExperience: 'المهارات والخبرة',
  reviews: 'المراجعات',
  documents: 'الوثائق',
  otherInfo: 'معلومات أخرى',
  noWorkExperienceDataAvailable: 'لا توجد بيانات خبرة عمل متاحة',
  selectART: 'اختيار ART',
  selectAnART: 'اختيار ART',
  jiraConfiguration: 'تكوين Jira',
  jiraProjectKey: 'مفتاح مشروع Jira',
  jiraURL: 'رابط Jira',
  jiraAdminEmail: 'بريد مدير Jira الإلكتروني',
  jiraAdminAPIToken: 'رمز API مدير Jira',
  jiraOpenStoryBugStatus: 'حالة القصة/الخطأ المفتوحة في Jira',
  jiraClosedStoryBugStatus: 'حالة القصة/الخطأ المغلقة في Jira',
  gitHubConfiguration: 'تكوين GitHub',
  gitHubUsername: 'اسم مستخدم GitHub',
  gitHubAPIToken: 'رمز API GitHub',
  gitHubRepositoryName: 'اسم مستودع GitHub',
  circleCIConfiguration: 'تكوين CircleCI',
  circleCIGitHubUsername: 'اسم مستخدم GitHub CircleCI',
  circleCIGitHubRepository: 'مستودع GitHub CircleCI',
  circleCIAPIToken: 'رمز API CircleCI',
  sonarQubeConfiguration: 'تكوين SonarQube',
  sonarQubeCloudURL: 'رابط SonarQube Cloud',
  sonarQubeAPIToken: 'رمز API SonarQube',
  awsConfiguration: 'تكوين AWS',
  awsAccessKeyID: 'معرف مفتاح الوصول AWS',
  awsSecretAccessKey: 'مفتاح الوصول السري AWS',
  awsRegion: 'منطقة AWS',
  bitBucketConfiguration: 'تكوين BitBucket',
  bitBucketUsername: 'اسم مستخدم BitBucket',
  bitBucketAppPassword: 'كلمة مرور تطبيق BitBucket',
  bitBucketWorkspace: 'مساحة عمل BitBucket',
  openAIConfiguration: 'تكوين OpenAI',
  openAIToken: 'رمز OpenAI',
  storyPointsCalculation: 'حساب نقاط القصة',
  uploadStoryPointsCalculationFile: 'رفع ملف حساب نقاط القصة',
  currentFile: 'الملف الحالي',
  notifications: 'الإشعارات',
  markAllAsRead: 'وضع علامة مقروء على الكل',
  tryAgain: 'حاول مرة أخرى',
  noNotificationsToDisplay: 'لا توجد إشعارات لعرضها',
  viewAllNotifications: 'عرض جميع الإشعارات',
  enterMultipleEmailsSeparatedByCommas: 'أدخل عدة رسائل بريد إلكتروني مفصولة بفواصل',
  addEmailAddressesToInvite: 'أضف عناوين بريد إلكتروني لدعوة أعضاء جدد',
  emailInvitationGuidelines: 'إرشادات دعوة البريد الإلكتروني',
  inviteesWillReceiveInstructions: 'سيتلقى المدعوون تعليمات للانضمام إلى هذا POD',
  theyWillNeedToCreateAccount: 'سيحتاجون إلى إنشاء حساب إذا لم يكن لديهم واحد بالفعل',
  noCandidatesAvailable: 'لا يوجد مرشحون متاحون',
  sendEmailInvites: 'إرسال دعوات البريد الإلكتروني',

  processingDataAndGeneratingInsights: 'معالجة البيانات وإنتاج الرؤى',
  retroHistory: 'تاريخ الاستعراض',
  filterByMember: 'فلترة حسب العضو',
  podProductivity: 'إنتاجية POD',
  totalTasks: 'إجمالي المهام',
  completed: 'مكتمل',
  clearFilters: 'مسح الفلاتر',
  totalActivities: 'إجمالي الأنشطة',
  pendingApproval: 'موافقة معلقة',
  sortBy: 'ترتيب حسب',
  editSolution: 'تحرير الحل',
  cannotDeleteAssociatedWithARTs: 'لا يمكن الحذف - مرتبط بـ ART',
  editART: 'تحرير ART',
  createdDate: 'تاريخ الإنشاء',
  podDetails: 'تفاصيل POD',
  currentARTProject: 'ART/المشروع الحالي',
  artProject: 'ART/المشروع',
  selectAvailability: 'اختيار التوفر',
  selectSkill: 'اختيار المهارة',
  selectTimezone: 'اختيار المنطقة الزمنية',
  selectLocation: 'اختيار الموقع',
  selectBudget: 'اختيار الميزانية',
  podMember: 'عضو POD',
  addToPod: 'إضافة إلى POD',
  talentDetails: 'تفاصيل المواهب',
  reviewsFeedback: 'المراجعات والملاحظات',
  noEducationDataAvailable: 'لا توجد بيانات تعليمية متاحة',
  noCertificationDataAvailable: 'لا توجد بيانات شهادات متاحة',
  clientReview: 'مراجعة العميل',
  noReviewsAvailableYet: 'لا توجد مراجعات متاحة حتى الآن',
  noClientReviews: 'لم يتلق هذا الموهبة أي مراجعات عملاء حتى الآن',
  resumeAvailable: 'السيرة الذاتية متاحة',
  viewDownloadResume: 'عرض أو تحميل سيرة المرشح الذاتية',
  noResumeAvailable: 'لا توجد سيرة ذاتية متاحة',
  noResumeUploaded: 'لم يرفع هذا الموهبة سيرة ذاتية.',
  codingAssessment: 'تقييم البرمجة',
  assessmentAvailable: 'التقييم متاح',
  viewAssessmentResults: 'عرض نتائج تقييم البرمجة للمرشح',
  noAssessmentAvailable: 'لا يوجد تقييم متاح',
  noAssessmentCompleted: 'لم يكمل هذا الموهبة تقييم البرمجة.',
  partnerCompanyDetails: 'تفاصيل الشركة الشريكة',
  companyIntroductionVideo: 'فيديو تعريف الشركة',
  videoNotSupported: 'متصفحك لا يدعم علامة الفيديو.',
  location: 'الموقع',
  noPodsMatchingCriteria: 'لم يتم العثور على POD تطابق معاييرك',
  hirePod: 'استئجار POD',
  notificationHistory: 'تاريخ الإشعارات',
  filter: 'فلتر',
  allNotifications: 'جميع الإشعارات',
  markSelected: 'وضع علامة على المحدد',
  unread: 'غير مقروء',
  noNotificationsFound: 'لم يتم العثور على إشعارات',
  searchNotifications: 'البحث في الإشعارات...',
  subscriptionManagement: 'إدارة الاشتراكات',
  choosePlanPrompt: 'اختر خطة تناسب احتياجاتك وتتوسع مع نموك',
  cancelSubscription: 'إلغاء الاشتراك',
  choosePlan: 'اختيار الخطة',
  noPlansAvailable: 'لا توجد خطط متاحة',
  noPlansHelpText: 'يرجى المراجعة لاحقاً أو الاتصال بالدعم للحصول على المساعدة.',
  currentPlanDetails: 'تفاصيل الخطة الحالية',
  renewalDate: 'تاريخ التجديد',
  subscriptionId: 'معرف الاشتراك',
  paymentMethod: 'طريقة الدفع',
  cardHolder: 'حامل البطاقة',
  expires: 'تنتهي في',
  brand: 'العلامة التجارية',
  billingHistory: 'تاريخ الفواتير',
  noInvoiceHistory: 'لا يوجد تاريخ فواتير متاح',
  needHelp: 'تحتاج مساعدة؟',
  supportText: 'إذا كان لديك أي أسئلة حول خطط الاشتراك أو تحتاج للمساعدة، فريق الدعم هنا لمساعدتك.',
  contactSupport: 'الاتصال بالدعم',
  completeSubscription: 'أكمل اشتراكك',
  planDetails: 'تفاصيل الخطة',
  planName: 'اسم الخطة',
  basePrice: 'السعر الأساسي',
  numberOfUsers: 'عدد المستخدمين',
  billingCycle: 'دورة الفوترة',
  orderSummary: 'ملخص الطلب',
  annualDiscount: 'خصم سنوي',
  billingPeriod: 'فترة الفوترة',
  tax: 'الضريبة',
  totalWithTax: 'المجموع مع الضريبة',
  annually: 'سنوياً',
  continue: 'متابعة',
  subscriptionSuccessful: 'نجح الاشتراك!',
  thankYouSubscribing: 'شكراً لك على الاشتراك في',
  subscriptionActivated: 'تم تفعيل اشتراكك بنجاح.',
  goToDashboard: 'الذهاب إلى لوحة التحكم',
  addPaymentMethod: 'إضافة طريقة دفع',
  cardNumber: 'رقم البطاقة',
  cardholderName: 'اسم حامل البطاقة',
  expiryMonth: 'شهر انتهاء الصلاحية',
  expiryYear: 'سنة انتهاء الصلاحية',
  postalCode: 'الرمز البريدي',
  addCard: 'إضافة بطاقة',
  paymentChoice: 'استخدم البطاقة الموجودة أو أضف بطاقة جديدة',
  existingCardText: 'لديك بالفعل بطاقة موجودة تنتهي بـ',
  useExistingCardPrompt: 'هل تريد استخدامها لهذا الاشتراك؟',
  useExistingCard: 'استخدام البطاقة الموجودة',
  addNewCard: 'إضافة بطاقة جديدة',
  processing: 'جاري المعالجة...',
  subscriptionSuccessDetails: 'نجح!',
  accessAllFeatures: 'يمكنك الآن الوصول إلى جميع الميزات المتضمنة في خطة اشتراكك.',
  editCardDetails: 'تعديل تفاصيل البطاقة',
  managerInvite: 'دعوة مدير',
  talentInvite: 'دعوة موهبة',
  invitePodManagers: 'أدخل البريد الإلكتروني لدعوة مديري البود',
  enterEmail: 'أدخل البريد الإلكتروني',
  invite: 'دعوة',
  yourInvoices: 'فواتيرك',
  noInvoices: 'ليس لديك أي فواتير.',
  amountDue: 'المبلغ المستحق',
  amountPaid: 'المبلغ المدفوع',
  getCountIsseswithNoCritria: 'احصل على عدد المشاكل بدون معايير القبول',
  noActiveSubscription: 'ليس لديك خطة اشتراك نشطة. يرجى النقر على رابط "اشتراك" لإضافة اشتراك.',
 noActiveSubscriptionStart: 'ليس لديك خطة اشتراك نشطة. يرجى النقر على',
  subscribe: 'اشتراك',
  noActiveSubscriptionEnd: 'رابط لإضافة اشتراك.'
  };

export default messagesAr;